<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import {
  WHATSAPP_QR_CHANNEL_SUBTYPE,
  WHATSAPP_QR_OUTGOING_URL,
} from 'dashboard/constants/whatsappQr';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      outgoingUrl: WHATSAPP_QR_OUTGOING_URL,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName?.trim(),
          channel: {
            type: 'api',
            webhook_url: WHATSAPP_QR_OUTGOING_URL,
            additional_attributes: {
              channel_subtype: WHATSAPP_QR_CHANNEL_SUBTYPE,
            },
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: inbox.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.WHATSAPP_QR.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP_QR.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP_QR.DESC')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP_QR.CHANNEL_NAME.LABEL') }}
          <input
            v-model="channelName"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP_QR.CHANNEL_NAME.PLACEHOLDER')"
            @blur="v$.channelName.$touch"
          />
          <span v-if="v$.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.WHATSAPP_QR.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP_QR.OUTGOING_URL.LABEL') }}
          <input
            :value="outgoingUrl"
            type="text"
            readonly
            class="cursor-not-allowed opacity-70"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP_QR.OUTGOING_URL.SUBTITLE') }}
        </p>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.WHATSAPP_QR.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
